import { render, staticRenderFns } from "./batch-save-dialog.vue?vue&type=template&id=0ab918b5&scoped=true&"
import script from "./batch-save-dialog.vue?vue&type=script&lang=js&"
export * from "./batch-save-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab918b5",
  null
  
)

export default component.exports